<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="700px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="text-h5 font-weight-bold">Duplicar Aula</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('dialogChange', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(enableSubmit)">
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Dados da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <label class="info-label">Tipo de Aula: </label>
                        <p class="info-value">{{ aulaDuplicada.tipo_de_aula }}</p>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label class="info-label">Data da Aula</e-label>
                          <v-text-field
                            dense
                            outlined
                            v-model="data"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          :allowed-dates="allowedDates"
                          scrollable
                          locale="pt-BR"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="error" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)"
                            >Confirmar</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Experiências
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>

                      <p>
                        {{ rotina.experiencias?.join(",  ") || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Direitos de Aprendizagem
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>

                      <ul>
                        <li v-for="campo in rotina.direitos_aprendizagem" :key="campo">
                          {{ campo || "- - -" }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Campos de experiências
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>

                      <ul>
                        <li v-for="campo in rotina.campos_experiencia_aula" :key="campo">
                          {{ campo || "- - -" }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Objetivos de Aprendizagem e Desenvolvimento
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>
                      <p>
                        {{ rotina.objetivos_aprendizagem || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Orientações Metodológicas
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>
                      <p>
                        {{ rotina.orientacoes_metodologicas || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Recursos
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>
                      <p>
                        {{ rotina.recursos || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Avaliação
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <div>{{ aulaDuplicada.avaliacao }}</div>
                </v-card-text>
              </v-card>

              <v-divider class="my-6"></v-divider>
              <e-progresso-preenchimento
                :expectedItems="itemsEsperados"
                :filledItems="itemsPreenchidos"
                @total-filled-changed="
                  (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                "
              />

              <v-card-actions class="px-0">
                <v-spacer></v-spacer>
                <v-btn color="error" outlined class="mr-3" @click="$emit('dialogChange', false)">
                  <v-icon left>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  depressed
                  :disabled="!totalmentePreenchido || temConflito"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
              </v-card-actions>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    />
    <aulas-em-conflitos v-model="sheetAulasEmConflito" :aulas="aulasEmConflito" />
  </v-row>
</template>
<script>
import AulasEmConflitos from "@/components/Aulas/AulasEmConflitos.vue";

export default {
  components: {
    AulasEmConflitos,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
  },
  data() {
    return {
      date: null,
      data: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      horariosFiltrados: [],
      aulasEmConflito: [],
      sheetAulasEmConflito: false,
      temConflito: false,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      itemsEsperados: [{ label: "Data", value: "dataAulaDuplicada" }],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) {
        this.data = null;
        this.horariosFiltrados = [];
        return;
      }
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
      const diaDaSemana = date.getDay(); // 0 = domingo, 1 = segunda, ..., 6 = sábado
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
      // Para aulas infantis, verifica conflito ao mudar a data
      this.verificarConflitoAula();
    },
    dialog: {
      handler(val) {
        if (!val) {
          // Limpa os estados quando o modal é fechado
          this.dataAulaDuplicada = null;
          this.data = null;
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
        }
      },
    },
  },
  created() {
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  methods: {
    async verificarConflitoAula() {
      if (!this.dataAulaDuplicada || !this.aulaDuplicada?.turma_id) {
        this.aulasEmConflito = [];
        this.sheetAulasEmConflito = false;
        this.temConflito = false;
        return;
      }

      try {
        const response = await this.$services.aulasService.getAulasInfantisEmConflito(
          this.dataAulaDuplicada,
          this.aulaDuplicada.turma_id
        );

        if (response.data?.length > 0) {
          this.aulasEmConflito = response.data;
          this.sheetAulasEmConflito = true;
          this.temConflito = true;
        } else {
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.gestaoDeAulas?.gestao?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          const todosHorarios = await this.$services.horariosService.horariosAll();
          horariosDoDia = todosHorarios;
        } else {
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },
    enableSubmit() {
      if (this.data) {
        this.confirmDialog = !this.confirmDialog;
        this.aulaDuplicada.data = this.dataAulaDuplicada;
      } else {
        this.$toast.danger("Por favor, preencha todos os campos");
      }
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.gestaoDeAulas.disciplina_id;
        this.aulaDuplicada.turma_id = this.gestaoDeAulas.turma_id;
        this.aulaDuplicada.instrutor_id = this.gestaoDeAulas.instrutor_id;
        await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        this.$toast.success("Aula duplicada com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>
<style scoped>
.info-field {
  margin-bottom: 12px;
}
.info-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}
.info-value {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}
.content-box {
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
}
</style>
